import React, { Component, Fragment } from 'react'
import ReactLightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'

class Lightbox extends Component {
  state = { isOpen: false }
  render() {
    return (
      <Fragment>
        {this.props.renderImage ? (
          this.props.renderImage({
            onClick: e => {
              e.stopPropagation()
              this.setState({ isOpen: true })
            },
          })
        ) : (
          <img src={this.props.thumbnail || this.props.src} alt="" />
        )}
        {this.state.isOpen && (
          <ReactLightbox
            mainSrc={this.props.src}
            imageTitle={this.props.title}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
      </Fragment>
    )
  }
}

export default Lightbox



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Lightbox.jsx